"use client";
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
} from "react-share";
import { useEffect, useState } from "react";
import { useTranslations } from "next-intl";

const removeHTMLTags = (str) => {
  if (!str) return "";
  return str.replace(/(<([^>]+)>)/gi, "")?.trim();
};

const SocialShareButtons = ({ title, subTitle }) => {
  const t = useTranslations();
  const [currentUrl, setcurrentUrl] = useState("");

  useEffect(() => {
    setcurrentUrl(window.location.href);
  }, []);

  return (
    <div className="my-5 d-print-none">
      <div className="mx-2 mb-2 bold">{t("share_story")}</div>
      <FacebookShareButton
        className="mx-1"
        url={currentUrl}
        title={title}
        hashtag="publicare"
      >
        <FacebookIcon size={36} round />
      </FacebookShareButton>
      <LinkedinShareButton
        className="mx-1"
        title={title}
        url={currentUrl}
        source={currentUrl}
        summary={subTitle}
      >
        <LinkedinIcon size={36} round />
      </LinkedinShareButton>
      <EmailShareButton
        className="mx-1"
        url={currentUrl}
        subject={`${title} | publicare.ch`}
        body={`${removeHTMLTags(subTitle)} \n\n`}
      >
        <EmailIcon size={36} round />
      </EmailShareButton>
    </div>
  );
};

export default SocialShareButtons;
